module.exports = __webpack_public_path__ + "img/similar-swit-recom.1e4ebe9f.png";